import React, { useState, useEffect } from "react";
import { getUKDate } from "./functions";

const CurrentTime: React.FC = () => {
  const [time, setTime] = useState("");

  useEffect(() => {
    const intervalId = setInterval(
      () =>
        setTime(
          getUKDate()
            .toLocaleTimeString([], {
              hour: "numeric",
              minute: "2-digit",
              hour12: true
            })
            .replace(" ", "")
        ),
      1000
    );
    return () => {
      clearInterval(intervalId);
    };
  }, []);

  return (
    <span className="h4 current-time hlpr-text-transform-none">{time}</span>
  );
};

export default CurrentTime;
